import { ENDPOINTS } from 'shared/constants';
import { TaskEntity } from 'shared/types';
import { Achievement, AchievementResponse, CompleteTaskResponse } from 'shared/types/api';
import { httpClientAuthorized } from '../httpClient';

export const getTasks = async () => {
  return await httpClientAuthorized.get<TaskEntity[]>(ENDPOINTS.GET_TASKS);
};

export const completeTask = async (taskId: string) => {
  return await httpClientAuthorized.post<CompleteTaskResponse>(ENDPOINTS.COMPLETE_TASK(taskId));
};

export const getAchievements = async () => {
  return await httpClientAuthorized.get<Achievement[]>('/v1/achievements/');
};

export const claimAchievement = async (achievementId: string) => {
  return await httpClientAuthorized.post<AchievementResponse>(
    `/v1/achievements/claim/${achievementId}`,
  );
};
